import useTypedFlags from "hooks/useTypedFlags";

import ContextsLegacy from "./Legacy";
import ContextsNew from "./New";

const Contexts = () => {
  const { contextsTableRedesign } = useTypedFlags();

  return contextsTableRedesign ? <ContextsNew /> : <ContextsLegacy />;
};

export default Contexts;
